import {memo, useCallback} from 'react'

import {useIsOverviewLinkSelected} from '../../../../hooks/routes'
import {getHasFavoriteProjects} from '../../../../selectors/projectTrees'
import type {ProjectId} from '../../../../types'
import {SubprojectContext} from '../../../common/NestedSubprojectsAndBuildTypes/NestedSubprojectsAndBuildTypesContext'
import {trendsOrBuildsHint} from '../../../packages/Hints/HintItems/Hints.projectOverview'
import {useHint} from '../../../packages/Hints/Hints.hooks'

import NestedContainer from './NestedProjectTrendsOrBuildsOverview.container'
import type {OwnProps} from './NestedProjectTrendsOrBuildsOverview.container'

import {useAppSelector} from 'src/hooks/react-redux'

function ProjectOverviewTab({projectId}: OwnProps) {
  useHint(trendsOrBuildsHint)
  const isOverview = useIsOverviewLinkSelected()
  const onlyFavorites = useAppSelector(
    state => (isOverview && getHasFavoriteProjects(state)) || false,
  )

  const nestedRender = useCallback(
    (nestedProjectId: ProjectId, level: number) => (
      <NestedContainer onlyFavorites={onlyFavorites} projectId={nestedProjectId} level={level} />
    ),
    [onlyFavorites],
  )

  return (
    <SubprojectContext.Provider value={nestedRender}>
      <NestedContainer level={0} onlyFavorites={onlyFavorites} projectId={projectId} />
    </SubprojectContext.Provider>
  )
}
export default memo(ProjectOverviewTab)
